export default __webpack_public_path__ + "static/media/ar_2019_image.99ae3afb.png";